import { keyframes } from 'antd-style'

export const reduceMotion = '@media (prefers-reduced-motion: reduce)'

export const skxFadeLift = keyframes`
  from { opacity: 0; transform: translateY(2px); }
  to { opacity: 1; transform: translateY(0); }
`
